import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CCRuble icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CCRuble } from '@sravni/design-system-icons'
 *
 * <CCRuble />
 * ```
 */
var CCRuble = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CCRuble", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.032 14.24a7.244 7.244 0 0 0 0-10.408 7.558 7.558 0 0 0-10.592 0 7.245 7.245 0 0 0 0 10.407M4.152 17.5h13.334H4.152v0ZM11.57 11.667H7.82", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.236 13.333v-7.5h2.648a1.77 1.77 0 0 1 0 3.54H7.82", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CCRuble };
//# sourceMappingURL=CCRuble.js.map
